'use client';

import { Suspense } from 'react';
import Disclaimer from '../components/Disclaimer';
import DisclaimerSkeleton from '../components/DisclaimerSkeleton';
import type { DisclaimerData } from '@/types/disclaimer';

interface DisclaimerClientProps {
  locale: string;
  data: DisclaimerData | null;
}

export default function DisclaimerClient({ locale, data }: DisclaimerClientProps) {
  return (
    <Suspense fallback={<DisclaimerSkeleton />}>
      <Disclaimer locale={locale} data={data} />
    </Suspense>
  );
}
